import "../../style/academics.css";

const MCA = () => {
  return (
    <>
      <div className="text2-UG mx-auto ms-lg-5">
        <b>Master of Computer Application (M.C.A.):</b>
      </div>
      <ul className="acad mx-auto ms-4 ms-md-5 ms-lg-5">
        <li>
          <b className="sub-head">Duration:</b> 2 Years
        </li>
        <li>
          <b className="sub-head">Admission Through:</b> CUET(PG)
        </li>
      </ul>
    </>
  );
};

export default MCA;
